// This file is injected by esbuild to make jQuery available globally
// for UMD/browser-globals packages like bootstrap-multiselect.
import jQuery from "jquery";
window.jQuery = window.$ = jQuery;
